module.exports = __webpack_public_path__ + "img/avatar-s-6.0c96c10d.jpg";